import { z } from "zod";

export const REPORT_TEMPLATE_VERSION = "profile-a4-v1" as const;
export const REPORT_SECTIONS = [
  "identification",
  "summary",
  "evolution",
  "assessment",
  "protocol",
  "exams",
  "nutrition",
  "training",
  "notes",
] as const;
export const reportSectionSchema = z.enum(REPORT_SECTIONS);
export type ReportSection = z.infer<typeof reportSectionSchema>;

const nullableText = z.string().max(500).nullable();
export const reportBrandingSnapshotSchema = z
  .object({
    display_name: nullableText,
    brand_name: nullableText,
    professional_title: nullableText,
    credential_label: nullableText,
    credential_value: nullableText,
    logo_path: nullableText,
    primary_color: z.string().regex(/^#[0-9a-f]{6}$/),
    phone: nullableText,
    email: nullableText,
    website: nullableText,
    footer_text: nullableText,
  })
  .strict();

export const reportSnapshotSchema = z
  .object({
    schema_version: z.literal(1),
    template_version: z.literal(REPORT_TEMPLATE_VERSION),
    generated_at: z.string().datetime(),
    period: z.object({ start: z.string().date(), end: z.string().date() }).strict(),
    selected_sections: z.array(reportSectionSchema).min(1),
    sections: z.record(z.string(), z.json()),
  })
  .strict();
export type ReportSnapshot = z.infer<typeof reportSnapshotSchema>;

export function safeReportFilename(value: string): string {
  const base = value
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, "-")
    .replace(/^-+|-+$/g, "")
    .slice(0, 100);
  return `${base || "relatorio"}.pdf`;
}
